(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zts-storefront"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initMotion() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const elements = document.querySelectorAll('.introduction-centered, .preview-section .section-heading, .preview-card, .curriculum .centered-heading, .author-copy, .audience-cards article, .offer-copy, .zts-start-steps li');
    const reveal = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        if (entry.target.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) entry.target.animate([{opacity:.25,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}], {duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
        reveal.unobserve(entry.target);
      });
    }, {threshold:.12});
    elements.forEach(element => {if (!element.dataset.ztsMotion) {element.dataset.ztsMotion='true';reveal.observe(element);}});
    const ambient = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('zts-in-view',entry.isIntersecting)), {threshold:0});
    document.querySelectorAll('.intro-book,.offer-art,.lesson-orbit').forEach(element => {if (!element.dataset.ztsAmbient) {element.dataset.ztsAmbient='true';ambient.observe(element);}});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initMotion); else initMotion();
  document.addEventListener('shopify:section:load',initMotion);
})();


  } catch(e) { console.error(e); }
})();
})();
